import {Card, Page, Text,Link} from '@shopify/polaris'
import React from 'react'

function FaqComponent() {
    let email = "mg12connect@gmail.com"
    return (
        <Page title="FAQ Page">
            <Card>
                <Text as="h2" variant="headingXl">
                    1) Basics:
                </Text>
                <br/>
                <div className="mg-faq-basic-faq">
                    <Text as="dd" variant="headingMd">
                        1.1) Will the currency change automatically based on the customer’s location?
                        <Text as="p">
                            Yes, the automatic currency conversion feature is available in the premium version of MG - Currency Converter. It detects the visitor’s location and switches the currency accordingly.
                        </Text>
                    </Text>
                    <Text as="dd" variant="headingMd">
                        1.2) Is this app compatible with Shopify Markets?
                        <Text as="p">
                            Yes, MG - Currency Converter supports with Shopify Markets.
                        </Text>
                    </Text>
                </div>
            </Card>
            <br/>
            <Card>
                <Text as="h2" variant="headingXl">
                    2) Rounding & Decimal & Hover options:
                </Text>
                <br/>
                <div className="mg-faq-basic-faq">
                    <Text as="dd" variant="headingMd">
                        2.1) Can I customize the rounding for converted prices?
                        <Text as="p">
                            Yes, MG - Currency Converter allows you to set custom rounding rules.
                        </Text>
                    </Text>
                    <Text as="dd" variant="headingMd">
                        2.2) How do I enable price rounding?
                        <Text as="p">
                            To activate the rounding feature, follow these steps:
                            Go to <b>Extra Configuration → Pricing Rules → Pricing Rounding Rules</b> Enable it.
                        </Text>
                    </Text>
                    <Text as="dd" variant="headingMd">
                        2.3) How do I hide decimal points in converted prices?
                        <Text as="p">
                            To remove decimals from the displayed prices, go to:
                            Go to <b>Extra Configuration → Pricing Rules → Remove Decimals</b> Enable it.
                        </Text>
                    </Text>
                    <Text as="dd" variant="headingMd">
                        2.4) How do I Show actual price on hover?
                        <Text as="p">
                            To show actual price on hover, go to:
                            Go to <b>Extra Configuration → Pricing Rules → Show Actual Price On Hover</b> Enable it.
                        </Text>
                    </Text>
                </div>
            </Card>
            <br/>
            <Card>
                <Text as="h2" variant="headingXl">
                    3) Switcher Placement:
                </Text>
                <br/>
                <div className="mg-faq-basic-faq">
                    <Text as="dd" variant="headingMd">
                        3.1) The currency switcher is not appearing on my store. How can I fix this?
                        <Text as="p">
                            If the switcher does not show up on your store, ensure you have followed the setup steps correctly. If the issue persists, grant us staff access with the following permissions:
                            <br/>
                            <b>Orders,Manage and Install Apps and Channels,Themes,Manage Settings</b>
                            <br/>
                            Once done, email us at <Link url={`mailto:${email}`}>{email}</Link> with your store details. Our team will review and provide a solution within 24 business hours.
                            <br/>
                            <b>Note:</b>If another switcher app is installed on your store, please disable it to avoid conflicts.
                        </Text>
                    </Text>
                    <Text as="dd" variant="headingMd">
                        3.2) How can I adjust the switcher’s position on my store?
                        <Text as="p">
                            You can easily reposition the currency switcher by navigating to: <br/>
                            Go to <b>Location / Design (Settings) → Location</b>.
                        </Text>
                    </Text>
                    <Text as="dd" variant="headingMd">
                        3.3) I set the switcher to appear in the header, but it’s not visible. Why?
                        <Text as="p">
                            If the switcher is not displaying inline with the header, additional theme adjustments may be required.<br/>
                            Please provide staff access to our team and email us at <Link url={`mailto:${email}`}>{email}</Link>, and we will assist you.
                        </Text>
                    </Text>
                    <Text as="dd" variant="headingMd">
                        3.4) Can I customize where the switcher appears?
                        <Text as="p">
                            Yes! We can modify the switcher placement based on your requirements. To request customization, grant staff access to your store and email the details to <Link url={`mailto:${email}`}>{email}</Link>.
                        </Text>
                    </Text>
                    <Text as="dd" variant="headingMd">
                        3.5) The switcher doesn’t appear on mobile. What should I do?
                        <Text as="p">
                            On mobile devices, the switcher is typically placed inside the navigation menu. If you’d like it positioned differently, please share your requirements with us at <Link url={`mailto:${email}`}>{email}</Link> , and we will assist you.
                        </Text>
                    </Text>
                </div>
            </Card>
            <br/>
            <Card>
                <Text as="h2" variant="headingXl">
                    4) Appearance Settings:
                </Text>
                <br/>
                <div className="mg-faq-basic-faq">
                    <Text as="dd" variant="headingMd">
                        4.1) How can I show the price with the currency code, like "$399 USD" instead of "$399"?
                        <Text as="p">
                            To adjust the price format and show the currency code along with the amount, follow these steps:<br/>
                            <b>Location / Design (Settings) → Design Settings → Price Format</b>
                        </Text>
                    </Text>
                    <Text as="dd" variant="headingMd">
                        4.2) Why is the currency name or code missing after the price?
                        <Text as="p">
                            If the currency code isn’t showing, it might be due to Shopify’s Multi-Currency feature being turned off. To fix this, please provide us with staff access, including these permissions:<br/>
                            <b>Orders, Manage and Install Apps and Channels, Themes, Manage Settings</b> <br/>
                            Once done, email us at <Link url={`mailto:${email}`}>{email}</Link>, and we will check and update your settings within 24 business hours.
                        </Text>
                    </Text>
                    <Text as="dd" variant="headingMd">
                        4.3) How can I change the color of the currency switcher?
                        <Text as="p">
                            You can update the switcher’s color scheme by following this path: <br/>
                            <b>Location / Design (Settings) → Design Settings → Advanced Customization</b> <br/>
                        </Text>
                    </Text>
                    <Text as="dd" variant="headingMd">
                        4.4) How do I make sure the currency switcher appears correctly on mobile?
                        <Text as="p">
                            For mobile optimization, our team can adjust the switcher’s placement based on your store’s theme. Please grant us staff access and send your request to <Link url={`mailto:${email}`}>{email}</Link>. We will apply the necessary changes within 24 hours.
                        </Text>
                    </Text>
                </div>
            </Card>
            <br/>
            <Card>
                <Text as="h2" variant="headingXl">
                    5) Cart Page Settings:
                </Text>
                <br/>
                <div className="mg-faq-basic-faq">
                    <Text as="dd" variant="headingMd">
                        5.1) How do I turn the cart notice on or off?
                        <Text as="p">
                            To enable or disable the cart notice, follow this path:<br/>
                            <b>Extra Configuration → Cart Notice</b> Enable/ Disable it.
                        </Text>
                    </Text>
                    <Text as="dd" variant="headingMd">
                        5.2) Why doesn’t the currency switch at checkout?
                        <Text as="p">
                            The MG - Currency Converter app applies currency changes up to the cart page. Shopify does not permit third-party apps to alter currency settings on the checkout page.
                        </Text>
                    </Text>
                    <Text as="dd" variant="headingMd">
                        5.3) Can my customers complete their purchase in their local currency?
                        <Text as="p">
                            <ul>
                                <li>
                                    If <b>Shopify Payments</b> is <b>not available</b> in your region, the checkout will always process transactions in your store’s default currency.
                                </li>
                                <li>
                                    If <b>Shopify Payments</b> is <b>enabled</b>, then email us at <Link url={`mailto:${email}`}>{email}</Link>.
                                </li>
                            </ul>
                        </Text>
                    </Text>
                </div>
            </Card>
            <br/>
            <Card>
                <Text as="h2" variant="headingXl">
                    6) Uninstallation Process:
                </Text>
                <br/>
                <div className="mg-faq-basic-faq">
                    <Text as="dd" variant="headingMd">
                        6.1) How can I safely remove the app from my store?
                        <Text as="p">
                            To uninstall the app properly, please email us at <Link url={`mailto:${email}`}>{email}</Link>, and our team will assist you with the necessary steps.
                        </Text>
                    </Text>
                </div>
            </Card>
            <br/>
            <Card>
                <Text as="h2" variant="headingXl">
                    7) Other Queries:
                </Text>
                <br/>
                <div className="mg-faq-basic-faq">
                    <Text as="dd" variant="headingMd">
                        7.1) I changed my theme, and the currency converter is not working. What should I do?
                        <Text as="p">
                            The MG - Currency Converter app requires setup for each theme separately. If you’ve switched to a new theme, please grant us staff access with the following permissions:<br/>
                            <b>Orders, Manage and Install Apps and Channels, Themes, Manage Settings</b><br/>
                            Once done, email us at <Link url={`mailto:${email}`}>{email}</Link>, and we will assist you with the setup.
                        </Text>
                    </Text>
                    <Text as="dd" variant="headingMd">
                        7.2) How do I provide staff access for assistance?
                        <Text as="p">
                            <ul>
                                <li>
                                    Log in to your Shopify admin.
                                </li>
                                <li>
                                    Go to <b>Settings → Users and Permissions</b>.
                                </li>
                                <li>
                                    Scroll down to Staff Members and click Add a staff member.
                                </li>
                                <li>
                                    <b>Enter First Name</b>: MG <br/>
                                    <b>Last Name</b>: Currency <br/>
                                    <b>Email:</b> <Link url={`mailto:${email}`}>{email}</Link>
                                </li>
                                <li>
                                    Assign the following permissions:<br/>
                                    <b>Orders, Manage and Install Apps and Channels, Themes,Manage Settings</b>
                                </li>
                                <li>
                                    Click <b>Send invite.</b>
                                </li>
                            </ul>
                        </Text>
                    </Text>
                    <Text as="dd" variant="headingMd">
                        7.3)  Is the app compatible with Shopify Online Store 2.0 themes?
                        <Text as="p">
                            Yes, our app is fully compatible with Shopify’s Online Store 2.0 themes.
                        </Text>
                    </Text>
                </div>
            </Card>
            <br/>
        </Page>
    )
}

export default FaqComponent
